@if (loading) {
  <pr-loader></pr-loader>
}

<ea-simulation-packs
  [packService]="packService"
  (packSelected)="onPackSelected($event)"
  [withTable]="false"
  [withCustomPack]="false"
  [withPanelTitle]="false"
  [suitableBaseOnScore]="score"
>
</ea-simulation-packs>

@if (resolutionError) {
  <info [option]="optionInfo1">
    {{ resolutionError }}
  </info>
}

@if (resolving) {
  <pr-loader></pr-loader>
}

<form-footer
  (prev)="prev()"
  (next)="onSubmit()"
  [disabledSkip]="true"
  [disabledNext]="!isPackComplete"
></form-footer>
<pr-modal
  clazz="pr-modal-confirm"
  display="neutral pack-change-modal-width"
  #modalPackChange
>
  <div class="pr-modal-confirm-header d-flex align-items-center gap-s mbl">
    <pr-icon name="warning"></pr-icon>
    <h4 class="man bold">Changement d'allocation type</h4>
  </div>
  <p class="mbl">
    Vous avez déjà travaillé sur la répartition issue de l'allocation type
    précédente (montants saisis ou supports ajoutés). En validant «
    {{ selectedPack?.name }} », cette répartition sera remplacée et vos
    modifications seront perdues.
  </p>
  <div class="d-flex justify-content-end gap-s">
    <pr-button
      display="neutral"
      variant="outline"
      size="lg"
      label="Annuler"
      (onClick)="cancelPackChange()"
    ></pr-button>
    <pr-button
      display="danger"
      size="lg"
      label="Remplacer la répartition"
      (onClick)="confirmPackChange()"
    ></pr-button>
  </div>
</pr-modal>
